// _app/immutable/assets/Wrapper.54de1bd5.css
export default ".main.svelte-sugxaq{display:flex;flex-direction:column;gap:5rem;padding:10rem 13rem}@media screen and (max-width:768px){.main.svelte-sugxaq{padding:5rem 2rem;gap:2rem}}\n";